<template>
  <div class="">
    <tabs
      v-model="active"
      color="#4FD9D5"
      title-active-color="#4FD9D5"
      title-inactive-color="#999999"
      line-width="50%"
      :border="true"
      sticky
    >
      <tab v-for="(item, index) in tabs" :key="index" :title="item">
        <div class="list">
          <list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <kevideo :order="false" :type="1" :list="list" />
          </list>
        </div>
      </tab>
    </tabs>
  </div>
</template>

<script>
/**
@description:课程列表
@createTime:2021-08-20
@create:wq
*/

import kevideo from "../../../components/kcvideo.vue";
import { Tab, Tabs, List } from "vant";

export default {
  name: "",
  props: {},
  components: { Tab, Tabs, kevideo, List },
  data() {
    return {
      active: 0,
      tabs: ["全部", "待付费", "已付费"],
      list: [],
      page: 1,
      loading: false,
      finished: false,
    };
  },
  computed: {},
  watch: {
    active() {
      this.loading = false;
      this.finished = false;
      this.list = [];
      this.page = 1;
      // this.onLoad();
    },
  },
  mounted() {},
  created() {},
  methods: {
    getList() {
      this.api
        .myOrder({ type: 3, status: this.active, page: this.page })
        .then((res) => {
          res.data.data.forEach((o) => (o.type = 1));
          this.list = [...this.list, ...res.data.data];
          if (res.data.to < res.data.per_page) {
            this.loading = true;
            this.finished = true;
          } else {
            this.loading = false;
          }
        });
    },
    onLoad() {
      this.getList();
      this.page++;
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  margin: 0 0.22rem;
}
</style>
